import { useMutation, useQueryClient } from '@tanstack/react-query';
import { reservationSpanPaymentLinkOptions } from '../../constants/reservationSpanPaymentLinks';
export function useReservationSpanPaymentLinkActions() {
    const queryClient = useQueryClient();
    const payMutation = useMutation(reservationSpanPaymentLinkOptions.pay());
    /** Read the link straight from the backend, bypassing the cache — e.g. to watch a BLIK payment settle. */
    const fetchReservationSpanPaymentLink = (filter) => queryClient.fetchQuery({ ...reservationSpanPaymentLinkOptions.get(filter), staleTime: 0, retry: false });
    return {
        fetchReservationSpanPaymentLink,
        payReservationSpanPaymentLink: payMutation.mutateAsync,
        payingReservationSpanPaymentLink: payMutation.isPending,
    };
}
